import Vue from 'vue';
import Vuex from 'vuex';
import MultiTenantService from '@/services/multiTenantService';
import auth from './auth.module';
import street from './street.module';
import document from './document.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tenantCode: '',
    tenantId: null,
    configuration: {
      cityPictures: [],
      blocs: [],
    },
    layout: 'DefaultLayout',
  },
  getters: {
    tenantCode: (state) => state.tenantCode,
    tenantId: (state) => state.tenantId,
    configuration: (state) => state.configuration,
    layout: (state) => state.layout,
  },
  actions: {
    setTenantCode({ commit }, tenantCode) {
      commit('setTenantCode', tenantCode);

      new MultiTenantService()
        .retrieveAuthorization(tenantCode)
        .then((data) => {
          commit('setTenantId', data.tenantId);
        })
        .catch((error) => {
          commit('setTenantId', '');
          console.log(error);
        });
    },
    setTenantId({ commit }, tenantId) {
      commit('setTenantId', tenantId);
    },
    setConfiguration({ commit }, configuration) {
      commit('setConfiguration', configuration);
    },
    setLayout({ commit }, layout) {
      commit('setLayout', layout);
    },
  },
  mutations: {
    setTenantCode(state, tenantCode) {
      state.tenantCode = tenantCode;
    },
    setTenantId(state, tenantId) {
      state.tenantId = tenantId;
    },
    setConfiguration(state, configuration) {
      const monthIndex = configuration.declarationEnd.split('/')[1] - 1;
      const day = configuration.declarationEnd.split('/')[0];
      configuration.declarationEnd = new Date(new Date(new Date().getFullYear(), monthIndex, day).setHours(23, 59, 59, 999));

      state.configuration = configuration;
    },
    setLayout(state, layout) {
      state.layout = layout;
    },
  },
  modules: {
    street,
    auth,
    document,
  },
});
